import { IconCircleFilled } from '@tabler/icons-react'


const ActiveCircle = () => {
  return (
    <div
      style={{
        display: 'flex',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'green',
        borderRadius: '50%',
        marginRight: '0.5rem',
      }}
    >
      <IconCircleFilled
        style={{
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: '#fff',
          borderRadius: '100%',
        }}
        color='green'
        size={20}
      />
    </div>
  )
}

export default ActiveCircle
